/*
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @Description: 主题设置
 * @FilePath: \onetab\src\store\theme.ts
 * @Date: 2024-03-19 17:14:31
 * @LastEditTime: 2024-04-11 17:32:33
 * @Author: lisushuang
 */

import { reactive } from "vue";

export const theme = reactive({
  light: 'light', // 浅色模式
  dark: 'dark', // 深色模式
  followSystem: false, // 跟随系统

  isSimpleMode: false, // 是否极简模式

  setFollowSystem() {
    this.followSystem = true;

    // todo 找到当前是深色模式还是浅色模式
  },
});
